import { render, staticRenderFns } from "./BackgroundClipping.vue?vue&type=template&id=cb22be1e&scoped=true&"
import script from "./BackgroundClipping.vue?vue&type=script&lang=ts&"
export * from "./BackgroundClipping.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundClipping.vue?vue&type=style&index=0&id=cb22be1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb22be1e",
  null
  
)

export default component.exports